'use client'

import { createContext, useContext } from 'react'

interface CampaignContextType {
  campaigns: Record<string, unknown[]>
}

const CampaignContext = createContext<CampaignContextType>({
  campaigns: {},
})

//Eg. const isActive = useCampaignActive('double_day')

export const useCampaignActive = (name: string) => {
  const context = useContext(CampaignContext)
  if (!context) {
    throw new Error('useCampaign must be used within a CampaignProvider')
  }

  const isActive = context.campaigns[`x-campaign-${name}`]

  return isActive
}

interface CampaignProviderProps {
  children: React.ReactNode
  campaigns: Record<string, unknown[]>
}

export function CampaignProvider({
  children,
  campaigns,
}: CampaignProviderProps) {
  return (
    <CampaignContext.Provider
      value={{
        campaigns,
      }}
    >
      {children}
    </CampaignContext.Provider>
  )
}
